import { Component, computed, effect, inject, untracked, viewChild, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatSidenavModule, MatSidenav } from '@angular/material/sidenav';
import { FilmComponent } from './component/film/film.component';
import { SideComponent } from './component/side/side.component';
import { MenuComponent } from './component/menu/menu.component';
import { HeadComponent } from './component/head/head.component';
import { CartComponent } from './component/cart/cart.component';
import { PageComponent } from './component/page/page.component';
import { ChatComponent } from './component/chat/chat.component';
import { FootComponent } from './component/foot/foot.component';
import { NoteComponent } from './component/note/note.component';
import { SideNavSignal } from './signal';

@Component({
    selector: 'app-root',
    imports: [NgClass, MatSidenavModule, FilmComponent, SideComponent, MenuComponent, HeadComponent, CartComponent, PageComponent, ChatComponent, FootComponent, NoteComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    private readonly sideNavSignal = inject(SideNavSignal);
    private readonly model = computed(() => this.sideNavSignal.render());

    size = computed(() => this.model()?.size ?? 'large');

    title = 'Mando';
    side = false;
    year: number;

    sidenav = viewChild(MatSidenav);

    private current: any;

    constructor(
    ) {
        this.year = new Date().getFullYear();

        effect(() => {
            const model = this.model();
            const sidenav = untracked(() => this.sidenav());

            if (sidenav) {
                if (model) {
                    if (model.hidden) {
                        sidenav.opened = false;
                    } else if (this.current !== model) {
                        sidenav.opened = true;
                    }
                    this.current = model;
                } else if (sidenav.opened) {
                    sidenav.toggle();
                }
            }
        });

        effect(() => {
            const model = this.sideNavSignal.render();
            const sidenav = untracked(() => this.sidenav());

            if (!model && sidenav) {
                sidenav.close();
            }
        });
    }

    onClose(): void {
        untracked(() => this.sideNavSignal.render.set(null));
    }
}
